import type { SVGProps } from 'react';
const DawnFlagNA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-NA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-NA_svg__a)">
      <path fill="#0C4799" d="M0 10.667 22 0H0z" />
      <path
        fill="#FFD243"
        d="m3.667 4.8-.802.904.06-1.216-1.194.062.888-.817-.888-.816 1.195.062-.061-1.217.802.905.801-.905-.06 1.217 1.194-.062-.888.816.888.817-1.195-.062.061 1.216z"
      />
      <path fill="#1BAC55" d="M0 16h22V5.333z" />
      <path fill="#fff" d="m2.422 18.133 21.284-13.54-4.127-6.726-21.284 13.541z" />
      <path fill="#E52347" d="M-.495 18.458 25.27 2.065l-2.776-4.523-25.765 16.393z" />
    </g>
  </svg>
);
export default DawnFlagNA;
